import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { useAuth } from '../../context/AuthContext';
import { useFieldLayout } from '../../hooks/useMedia';
import { EmployeeToolLog } from '../../modules/ToolFundDashboard/components/EmployeeToolLog';
import { ToolLogPhone } from '../../modules/ToolFundDashboard/phone/ToolLogPhone';

export const Route = createFileRoute('/toolLog/')({
  component: RouteComponent,
  // Phones and tablets open a tool request as a page: in the URL, so a refresh keeps it and the
  // phone's Back steps out. Desktop doesn't read it.
  validateSearch: z.object({
    request: z.coerce.number().int().positive().optional(),
  }),
});

function RouteComponent() {
  const loggedInUserId = useAuth().user.id;
  const isFieldLayout = useFieldLayout();
  if (isFieldLayout) {
    return <ToolLogPhone userId={loggedInUserId} />;
  }
  return <EmployeeToolLog userId={loggedInUserId} />;
}
